import React, { FC, useEffect } from "react";
import "./SaveNotification.scss";

interface SaveNotificationProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const SaveNotification: FC<SaveNotificationProps> = ({
  message,
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className="position-fixed w-100 h-100 start-0 top-0 bg-black-60 z-3">
      <div className="position-absolute top-50 start-50 translate-middle">
        <div className="d-flex flex-column flex-lg-row gap-5 align-items-center justify-content-center bg-white py-25px px-20px px-md_40px radius-8px">
          <svg
            className="min-w-24px"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#167E76" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.3683 9.13327C16.5445 9.31036 16.5438 9.59679 16.3667 9.77303L10.4575 15.654C10.281 15.8296 9.99577 15.8296 9.81928 15.654L7.13327 12.9808C6.95618 12.8046 6.95549 12.5181 7.13173 12.3411C7.30798 12.164 7.59441 12.1633 7.77149 12.3395L10.1384 14.6951L15.7285 9.13173C15.9056 8.95549 16.192 8.95618 16.3683 9.13327Z"
              fill="white"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="fs-22 fs-mobile-16 fw-400 text-black text-center">
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveNotification;
